import { Injectable } from '@angular/core';
import { LegacyRippleGlobalOptions } from '@angular/material/legacy-core';

@Injectable({ providedIn: 'root' })
export class GlobalRippleOptions implements LegacyRippleGlobalOptions {
  disabled = true;
}
